// src/Admin/AdminNews.js
import React, { useState, useEffect } from "react";
import useEventStore from "../stores/EventStore";
import DynamicDateInputs from "../components/DynamicDateInputs"; // Importiere die DynamicDateInputs-Komponente


const AdminNews = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [template, setTemplate] = useState("default"); // Zustand für das Template
  const [status, setStatus] = useState(null);
  const { createEvent, dateInputs } = useEventStore();


  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleContentChange = (e) => setContent(e.target.value);
  const handleTemplateChange = (e) => setTemplate(e.target.value);

  useEffect(() => {

  }, []);

  const handleSaveNews = async () => {
    const eventData = {
      headline: title,
      news: content,
      template,
      dateInputs: dateInputs,
    };

    createEvent(eventData);
    setStatus("success");
    window.location.reload(); // <- This will refresh the page
  };


  return (
    <div className="admin-container">
      <h2>Admin Bereich</h2>
      <div>
        <label>Überschrift:</label>
        <input
          type="text"
          value={title}
          onChange={handleTitleChange}
          placeholder="Gib eine Überschrift ein"
        />
      </div>
      <div>
        <label>Text:</label>
        <textarea
          value={content}
          onChange={handleContentChange}
          placeholder="Gib den News-Text ein"
        />
      </div>
      <div>
        <label>Template:</label>
        <select value={template} onChange={handleTemplateChange}>
          <option value="default">Standard</option>
          <option value="autumn-template">Herbst Template</option>
          <option value="summer-template">Sommer Template</option>
          <option value="winter-template">Winter Template</option>
          {/* Weitere Templates hier hinzufügen */}
        </select>
      </div>
      <DynamicDateInputs />
      <button onClick={handleSaveNews}>
        News speichern
      </button>
      {status === "success" && <p className="success-message">News erfolgreich gespeichert!</p>}
    </div>
  );
};

export default AdminNews;


